import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination, Virtual } from "swiper";
import { BREAKPOINTS } from "utils";

class MediaCarousel extends HTMLElement {
    #e;
    #i;
    #t;
    #s = null;
    #a;
    #r;
    #n;
    #l;
    #d = null;
    #o;

    static #h = "swiper";
    static #p = "swiper-wrapper";
    static #u = "swiper-slide";

    constructor() {
        super();
        this.#e = this.#c.bind(this);
    }

    connectedCallback() {
        this.#l = this.querySelector("media-carousel-slider");
        this.#o = this.querySelector("media-carousel-wrapper");
        this.#n = this.querySelectorAll("media-carousel-slide");
        this.#r = this.querySelector("media-carousel-pagination");
        this.#a = this.querySelector("media-carousel-navigation");
        this.#i = this.dataset.loop ? "realIndex" : "activeIndex";
        this.#t = Boolean(this.dataset.virtual && this.querySelector(".js-slides"));
        this.breakpointMin = Object.keys(BREAKPOINTS).includes(this.dataset.breakpointMin) ? BREAKPOINTS[this.dataset.breakpointMin] : Number(this.dataset.breakpointMin || "0");
        this.breakpointMax = Object.keys(BREAKPOINTS).includes(this.dataset.breakpointMax) ? BREAKPOINTS[this.dataset.breakpointMax] : Number(this.dataset.breakpointMax || "0");

        new IntersectionObserver((e, i) => {
            e.forEach((e) => {
                if (e.isIntersecting) {
                    i.unobserve(this);
                    if (this.breakpointMin || this.breakpointMax) {
                        this.#s = window.matchMedia(`(${this.breakpointMin ? `min-width: ${this.breakpointMin}px${this.breakpointMax ? " and " : ""}` : ""}${this.breakpointMax ? `max-width: ${this.breakpointMax - 1}px` : ""})`);
                        this.#s.matches && this.#v();
                        this.#s.addEventListener("change", this.#e);
                    } else {
                        this.#v();
                    }
                }
            });
        }).observe(this);
    }

    disconnectedCallback() {
        this.#d && (this.#d.destroy(), this.#d = null);
        this.#s && this.#s.removeEventListener("change", this.#e);
    }

    get initialized() {
        return Boolean(!!this.#d && (this.#t ? this.#d.virtual.cache[this.#d[this.#i]] : this.#d.slides[this.#d[this.#i]]));
    }

    get index() {
        return this.#d ? this.#d[this.#i] : void 0;
    }

    get currentSlide() {
        return this.#d ? this.#t ? this.#d.virtual.cache[this.#d[this.#i]] : this.#d.slides[this.#d[this.#i]] : void 0;
    }

    slideTo(e, i = 0) {
        if (!("number" == typeof e && e >= 0)) throw new Error("Invalid slide index");
        return this.dataset.loop ? this.#d.slideToLoop(e, i) : this.#d.slideTo(e, i), this.#d.update(), this.#d;
    }

    stop() {
        return this.#d?.autoplay ? (this.#d.autoplay.stop(), this.#d) : this.#d;
    }

    start() {
        return this.#d?.autoplay ? (this.#d.autoplay.start(), this.#d) : this.#d;
    }

    on(e, i, t) {
        return this.addEventListener(e, i, t), this;
    }

    off(e, i, t) {
        return this.removeEventListener(e, i, t), this;
    }

    #v() {
        this.#d || (
            this.#l.classList.add(MediaCarousel.#h),
            this.#o && this.#o.classList.add(MediaCarousel.#p),
            this.#n.length > 0 && this.#n.forEach((e) => e.classList.add(MediaCarousel.#u)),
            this.#r && this.#r.removeAttribute("hidden"),
            this.#a && this.#a.removeAttribute("hidden"),
            this.#d = new Swiper(this.#l, {
                autoHeight: Boolean(this.dataset.autoHeight),
                initialSlide: Number(this.dataset.initialSlide || 0),
                loop: Boolean(this.dataset.loop),
                modules: [A11y, ...this.dataset.autoplay ? [Autoplay] : [], ...this.dataset.fade ? [EffectFade] : [], ...this.dataset.navigation ? [Navigation] : [], ...this.dataset.pagination ? [Pagination] : [], ...this.#t ? [Virtual] : []],
                observer: !0,
                observeParents: !0,
                slidesPerGroup: Number(this.dataset.slidesPerGroup || 1),
                spaceBetween: Number(this.dataset.spaceBetween || 30),
                speed: Number(this.dataset.speed || 200),
                ...(this.dataset.enableBreakpoint ? {
                    breakpoints: {
                        768: { slidesPerView: 1, spaceBetween: 30 },
                        1024: { slidesPerView: 3, spaceBetween: 40 },
                        1280: { slidesPerView: 3, spaceBetween: 50 }
                    }
                } : {}),
                ...(this.dataset.autoplay ? { autoplay: { delay: Number(this.dataset.autoplay || 3e3) } } : {}),
                ...(this.dataset.fade ? { effect: "fade", fadeEffect: { crossFade: !0 } } : {}),
                ...(this.dataset.navigation ? { navigation: { nextEl: this.querySelector(".js-carousel-next"), prevEl: this.querySelector(".js-carousel-prev") } } : {}),
                ...(this.dataset.pagination ? { pagination: { clickable: !0, el: this.querySelector(".js-carousel-pagination") } } : {}),
                ...(this.#t ? { virtual: { slides: (() => Array.from(this.querySelector(".js-slides").children).map((e => e.innerHTML)))() } } : {}),
                on: {
                    afterInit: e => {
                        const i = this.querySelector("media-carousel-preview-image");
                        i && i.setAttribute("hidden", "");
                        const t = setInterval(() => {
                            const i = this.#t ? e.virtual.cache[e[this.#i]] : e.el?.querySelector(".swiper-slide-active"),
                                s = () => {
                                    this.dispatchEvent(new CustomEvent("on:media-carousel:init", { detail: { currentSlide: i, activeIndex: e[this.#i] } })),
                                        this.classList.remove("is-loading"),
                                        this.classList.add("is-initialized"),
                                        i.classList.add("is-visible");
                                };
                            i && (s(), clearInterval(t));
                        }, 5);
                    },
                    slideChange: e => {
                        const i = setInterval(() => {
                            const t = this.#t ? e.virtual.cache[e[this.#i]] : e.el?.querySelector(".swiper-slide-active");
                            t && ((() => {
                                this.dispatchEvent(new CustomEvent("on:media-carousel:slide-change", { detail: { currentSlide: t, activeIndex: e[this.#i], previousIndex: e.previousIndex, previousSlide: this.#t ? e.virtual.cache[e.previousIndex] : e.el?.querySelector(".swiper-slide-prev") } }));
                            })(), clearInterval(i));
                        }, 5);
                    },
                    slideChangeTransitionStart: e => {
                        const i = setInterval(() => {
                            const t = this.#t ? e.virtual.cache[e[this.#i]] : e.el?.querySelector(".swiper-slide-active"),
                                s = this.#t ? e.virtual.cache[e.previousIndex] : e.el?.querySelector(".swiper-slide-prev"),
                                a = () => {
                                    this.dispatchEvent(new CustomEvent("on:media-carousel:before-slide-change", { detail: { currentSlide: t, previousSlide: s, activeIndex: e[this.#i], previousIndex: e.previousIndex } })),
                                        t.classList.add("is-visible");
                                };
                            t && (a(), clearInterval(i));
                        }, 5);
                    },
                    transitionEnd: e => {
                        const i = this.#t ? e.virtual.cache[e[this.#i]] : e.el?.querySelector(".swiper-slide-active"),
                            t = this.#t ? e.virtual.cache[e.previousIndex] : e.el?.querySelector(".swiper-slide-prev");
                        t?.classList.remove("is-visible"),
                            this.dispatchEvent(new CustomEvent("on:media-carousel:slide-transition-end", { detail: { currentSlide: i, previousSlide: t, activeIndex: e[this.#i], previousIndex: e.previousIndex } }));
                    }
                }
            })
        );
    }

    #m() {
        this.#d && (this.#d.destroy(), this.#d = null, this.#l.classList.remove(MediaCarousel.#h), this.querySelector("is-visible")?.classList.remove("is-visible"), this.#o && this.#o.classList.remove(MediaCarousel.#p), this.#n.length > 0 && this.#n.forEach((e => e.classList.remove(MediaCarousel.#u))), this.#r && this.#r.setAttribute("hidden", ""), this.#a && this.#a.setAttribute("hidden", ""));
    }

    #c(e) {
        e.matches && !this.#d ? this.#v() : this.#d && this.#m();
    }
}

customElements.define("media-carousel", MediaCarousel);